import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@fortawesome/fontawesome-free/css/all.css'

// Touch & swipe support
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// Sentry error tracking
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

// Intercom
import VueIntercom from 'vue-intercom'

if(process.env.NODE_ENV != 'development') {
  Sentry.init({
    dsn: 'https://5dd075cb92074b328c66efa7087ada0a@sentry.io/1515733',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
  })

  Vue.use(VueIntercom, { appId: 'kemuxrbz' })
}

Vue.config.productionTip = false

import errorHandler from '@/components/ErrorHandler.vue'

Vue.prototype.$error = errorHandler.methods.error

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
